module.exports = __webpack_public_path__ + "img/antamil.3e1bcb76.jpeg";